let VCA = VCA || {};

VCA.RedirectDeviceType = (function ($) {

    let isMobileDevice = false;

    function checkElementExists() {
        if ($('.mobile-redirect').length > 0) {
            detectOnLoad();
        }
    }

    function detectOnLoad() {
        let os = getMobileOperatingSystem();
        let IOSUrl = mobileIOSAppStoreUrl;
        let AndroidUrl = mobileAndroidAppStoreUrl;

        if (os == 'Android' || os == 'iOS') { 
            isMobileDevice = true;
            $('.mobile-redirect').attr('href', ''); //remove href 

            if (os == 'Android') {
                $('.mobile-redirect').attr({
                    href: AndroidUrl,
                    target: '_blank'
                });
            } else if ( os == 'iOS') {
                $('.mobile-redirect').attr({
                    href: IOSUrl,
                    target: '_blank'
                });
            }

        } else {
            isMobileDevice = false;
            return;
        }
    }

    function getMobileOperatingSystem() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
        if (/android/i.test(userAgent)) {
            return "Android";
        }
      
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
      
        return "Not a mobile device";
    }
    
    function init() {
        checkElementExists();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.RedirectDeviceType.init();
});

